import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import AccountsRouter from "./router";
import { AuthContext } from "./context";
import { getAzureConfig } from "./azure";
import { refreshToken } from "./token";

export default function AuthRouterAndContext({
  host,
  hideMicrosoftSSO,
  azureConfig,
  postLoginPage,
  children,
}) {
  azureConfig = azureConfig || getAzureConfig();

  useEffect(() => {
    console.log("Authentication host =", host);

    // Try to refresh token from httpCookie on init if possible
    refreshToken();
  }, [host]);

  return (
    <AuthContext.Provider
      value={{ host, hideMicrosoftSSO, azureConfig, postLoginPage }}
    >
      <Switch>
        {/* All paths for accounts signup, login, password and sso */}
        <Route path="/accounts" component={AccountsRouter} />

        {/* Wrapping these children */}
        <Route render={() => children} />
      </Switch>
    </AuthContext.Provider>
  );
}
